import React, { useEffect, useState, useRef, useCallback } from "react";

import { useLanguageContext } from "../../Context/LanguageContext";
import { _helper } from "../GlobalFunction/dateHelper";

import SearchBox_new from "../FilterOptions/SearchComponent/SearchBox_new";

export default function EquipmentFilterPopOver(props) {
  const { setIsFilterVisible, setFilterValue, filterList, filterValue } = props;

  const [conditions, setConditions] = useState([]);

  useEffect(() => {
    // Initialize conditions. If filterValue is empty, provide a default empty condition.
    // This ensures SearchBox_new always has at least one row to render.
    if (filterValue && filterValue.length > 0) {
      setConditions(filterValue);
    } else {
      setConditions([{ Name: "", Operator: "", Value: "" }]);
    }
  }, [filterValue]);

  function handleSubmit() {
    setIsFilterVisible(false);
    setFilterValue(conditions);
  }

  const handleConditionChange = useCallback((_value) => {
    setConditions((prev) => _value);
  }, []);

  const toggleFilter = () => {
    // Just close the popover, don't save any state
    setIsFilterVisible((prev) => !prev);
  };
  return (
    <>
      <SearchBox_new
        filterList={filterList}
        saveFilterList={[]}
        conditions={conditions}
        setConditions={handleConditionChange}
        toggleFilter={toggleFilter}
        reportCode={""}
        handleFilterOpertation={handleSubmit}
        handleFiltersave={() => {}}
        handleDelFilterSuccess={() => {}}
        isShowSaveFilterDropDown={false}
        showSaveButton={false}
      />
    </>
  );
}
